module.exports = "<label *ngIf=\"showCaption\">\r\n    {{caption}}</label>\r\n\r\n    <input [disabled]=\"disabled\" (keypress)=\"innerChange($event);\"  type=\"number\" class=\"form-control ixsControl\" [(ngModel)]=\"value\" (blur)=\"onBlur()\" [placeholder]=\"placeholder\" >\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixsnumeric/ixsnumeric.component.html
// module id = 1053
// module chunks = 22